export default __webpack_public_path__ + "static/media/D4.ba0785c1.png";